export const imageRekognition = async (file, url: string) => {
  const formData = new FormData()
  formData.append('files', file)

  return fetch(`${url}/image-rekognition`, {
    method: 'POST',
    body: formData
  })
    .then((res) => res.json())
    .then((res) => res)
}

export const searchDataFromText = async (formData, url: string) => {
  return fetch(`${url}/search-data-from-text`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then((res) => res.json())
    .then((res) => res)
}

export const getCarInfo = async (vin: string) => {
  return fetch(`https://tvstuning.com/search/${vin}`)
    .then((res) => res.json())
    .then((res) => res)
}

export const getCountries = async (url: string) => {
  return fetch(`${url}/erpnext?doctype=Country&fields=["name"]&filters=[]&limit=none`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
  })
    .then((res) => res.json())
    .then((res) => res?.data?.map(country => country.name))
}
